import {
  CABINET,
} from '../actions/constants';

const initialState = {
  handling: false,
  data: {},
};

export default function Cabinet(state = initialState, action) {
  switch (action.type) {
    case CABINET.handlers.fetch:
    case CABINET.handlers.update:
    case CABINET.handlers.remove:
      return {
        ...state,
        handling: true,
      };
    case CABINET.update:
      return {
        ...state,
        data: action.merge ? {
          ...state.data,
          ...action.data,
        } : action.data,
        handling: false,
      };
    default:
      return state;
  }
}
